var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterestedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.6646C15.748 19.6646 19.6577 15.7549 19.6577 11.0068C19.6577 6.26709 15.7397 2.34912 10.9917 2.34912C6.25195 2.34912 2.34229 6.26709 2.34229 11.0068C2.34229 15.7549 6.25195 19.6646 11 19.6646ZM8.96631 7.27979C9.9043 7.27979 10.6016 7.81934 11 8.5249C11.3901 7.81934 12.0957 7.27979 13.0254 7.27979C14.4282 7.27979 15.4824 8.35059 15.4824 9.88623C15.4824 12.3101 12.8013 14.3188 11.4648 15.1738C11.3237 15.2651 11.1411 15.3813 11.0083 15.3813C10.8838 15.3813 10.6763 15.2651 10.5269 15.1738C9.18213 14.3354 6.50928 12.3101 6.50928 9.88623C6.50928 8.35059 7.56348 7.27979 8.96631 7.27979Z",
    fill: "#FF2D55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestedIcon);
export default __webpack_public_path__ + "static/media/interestedIcon.c4d4b3905690b5535f005269d5b62ec5.svg";
export { ForwardRef as ReactComponent };